import React from 'react';
import cn from 'classnames';

import { Tooltip } from '@components/common';

import styles from './CategoriesList.module.scss';

interface ICategoriesListProps {
	categories: {
		name: string;
		disabled?: boolean;
	}[];
	disableTooltip?: string;
}

const CategoriesList = ({
	categories,
	disableTooltip,
}: ICategoriesListProps) => (
	<div className={styles.categoriesListContainer}>
		{categories.map((category, i) => (
			<Tooltip
				key={`${category}+${i}`}
				content={disableTooltip}
				isDisabled={!disableTooltip || !category.disabled}
			>
				<div className={cn(styles.category, { [styles.disabled]: category.disabled })}>
					{category.name}
				</div>
			</Tooltip>
		))}
	</div>
);

export default CategoriesList;
